import { API_URL } from '@/config';
import { axios } from '@/lib/axios';
import type { QuizV2CreateRequestBody } from '@/features/Quiz/utils/buildQuizV2CreatePayload';
import type { AdminQuizDetailsSection, QuizV2UpdateRequestBody } from '@/features/Quiz/utils/quizV2AdminEdit';

export type LibraryQuizDetailsV2 = {
    quiz: {
        id: number;
        uuid: string;
        title: string;
        type: string;
        status: string;
        startTime: string | null;
        endTime: string | null;
        durationInMinutes: number | null;
        maxAttemptCount: number;
        evaluationType: string;
        accessType: string;
        creatorType?: string;
    };
    sections: AdminQuizDetailsSection[];
    libraryMappingId: number;
    libraryType: string;
    joveSectionId: number | null;
    locale: string | null;
};

export type UpdateLibraryQuizV2RequestBody = QuizV2UpdateRequestBody & {
    libraryType?: string;
    joveSectionId?: number | null;
    locale?: string | null;
};

export type CreateLibraryQuizV2RequestBody = QuizV2CreateRequestBody & {
    libraryType: string;
    joveSectionId: number | null;
    joveDomainId?: number | null;
    locale?: string | null;
};

export const getLibraryQuizV2 = (quizUuid: string): Promise<LibraryQuizDetailsV2> =>
    axios.get(`${API_URL}/api/v2/admin/quiz/library/${quizUuid}`);

export const createLibraryQuizV2 = (
    data: CreateLibraryQuizV2RequestBody
): Promise<LibraryQuizDetailsV2> => axios.post(`${API_URL}/api/v2/admin/quiz/library`, data);

export const updateLibraryQuizV2 = (
    quizUuid: string,
    data: UpdateLibraryQuizV2RequestBody
): Promise<LibraryQuizDetailsV2> =>
    axios.patch(`${API_URL}/api/v2/admin/quiz/library/${quizUuid}`, data);

export const deleteLibraryQuizV2 = (quizUuid: string): Promise<void> =>
    axios.delete(`${API_URL}/api/v2/admin/quiz/library/${quizUuid}`);
